import React, { useState } from "react";
import { BASE_URL } from "../env";
const Resetpasswordus = () => {
	const [email, setemail] = useState("");
	const [password, setpassword] = useState("");
	function ResetPassword() {
		fetch(BASE_URL + "/changepassword", {
			method: "POST",
			headers: {
				"Content-type": "application/json",
			},
			body: JSON.stringify({
				email: email,
				password: password,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				alert(data.message);
			});
		// fetch request maaarke alert show kardo
	}

	return (
		<div>
			<div
				className="d-flex flex-column"
				style={{ margin: "20px 350px", padding: "20px", width: "50%" }}
			>
				<h2>Reset Password</h2>
				<input
					value={email}
					onChange={(e) => setemail(e.target.value)}
					placeholder="Email"
					style={{ margin: "20px", border: "1px solid grey" }}
				/>
				<br />
				<input
					value={password}
					placeholder="Password"
					onChange={(e) => setpassword(e.target.value)}
					style={{ margin: "20px", border: "1px solid grey" }}
				/>
				<br />

				<button
					type="button"
					class="btn btn-success "
					style={{ width: "50%", marginLeft: "150px" }}
					onClick={() => {
						ResetPassword();
					}}
				>
					Change the password
				</button>
			</div>
		</div>
	);
};

export default Resetpasswordus;
